import { TLanguage, TUserType } from 'contexts/app-context/types'

import { TUnavailableFeatureContent } from '../types/UnavailableFeature.types'

const fallbackUnavailableFeature: Record<TLanguage, TUnavailableFeatureContent> = {
  'pt-BR': {
    title: 'Perguntas ou solicitações ?',
    details:
      'Se você tiver qualquer pergunta ou solicitação a respeito de como Inter&Co lida com suas informações pessoais, nos contate em',
    email: '',
    button: 'Fechar',
    icon: 'core/status/ic_warning_circle',
    type: 'warning',
  },
  'es-ES': {
    title: 'Preguntas o solicitudes?',
    details:
      'Si tienes alguna pregunta o solicitud sobre cómo Inter&Co procesa tu información personal, por favor contáctanos en',
    email: '',
    button: 'Cerrar',
    icon: 'core/status/ic_warning_circle',
    type: 'warning',
  },
  'en-US': {
    title: 'Questions or requests?',
    details:
      'If you have any questions or requests regarding how Inter&Co process your personal information, please contact us at',
    email: '',
    button: 'Close',
    icon: 'core/status/ic_warning_circle',
    type: 'warning',
  },
}

const setFallbackUnavailableContent = (
  language?: TLanguage,
  organization?: TUserType,
): TUnavailableFeatureContent => {
  const email = organization && organization === 'AR' ? 'privacidad@inter.co' : 'privacy@inter.co'

  if (!language) {
    return {
      title: 'Questions or requests?',
      details:
        'If you have any questions or requests regarding how Inter&Co process your personal information, please contact us at',
      email,
      button: 'Close',
      icon: 'core/status/ic_warning_circle',
      type: 'warning',
    }
  }

  const content = fallbackUnavailableFeature[language]

  if (!content)
    return {
      title: 'Questions or requests?',
      details:
        'If you have any questions or requests regarding how Inter&Co process your personal information, please contact us at',
      email,
      button: 'Close',
      icon: 'core/status/ic_warning_circle',
      type: 'warning',
    }

  return { ...content, email }
}

export { setFallbackUnavailableContent }
